var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "entry-multi-tab" }, [
    _c(
      "main",
      { staticClass: "entry-multi-tab__wrapper" },
      [
        _c(
          "a-tabs",
          {
            attrs: {
              hideAdd: "",
              type: "editable-card",
              activeKey: _vm.activeKey,
            },
            on: { change: _vm.onChange, edit: _vm.onEdit },
          },
          [
            _vm._l(_vm.panes, function (pane, index) {
              return _c(
                "a-tab-pane",
                { key: pane.key, attrs: { closable: pane.closable } },
                [
                  index === 0
                    ? _c("a-icon", {
                        attrs: { slot: "tab", type: "home" },
                        slot: "tab",
                      })
                    : _c("span", { attrs: { slot: "tab" }, slot: "tab" }, [
                        _vm._v(_vm._s(_vm._f("menuNameRender")(pane))),
                      ]),
                ],
                1
              )
            }),
            _c(
              "div",
              {
                attrs: { slot: "tabBarExtraContent" },
                slot: "tabBarExtraContent",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "demo",
                        rawName: "v-demo",
                        value: "guideToLive",
                        expression: "'guideToLive'",
                      },
                    ],
                    staticClass: "entry-oguide",
                    staticStyle: { "border-right": "1px solid #E5E8EB" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "13",
                          height: "13",
                          viewBox: "0 0 13 13",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M4.69043 4.52224C4.69043 4.255 4.88015 4.14503 5.11275 4.27576L8.88836 6.39733C9.12157 6.52842 9.12096 6.74135 8.88836 6.87196L5.11275 8.99354C4.87954 9.12463 4.69043 9.0143 4.69043 8.74705V4.52224Z",
                            fill: "white",
                            stroke: "#4E535C",
                          },
                        }),
                        _c("circle", {
                          attrs: {
                            cx: "6.33789",
                            cy: "6.875",
                            r: "5.625",
                            stroke: "#4E535C",
                          },
                        }),
                      ]
                    ),
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(_vm._s(_vm.$t("layouts.直播/回放"))),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "demo",
                        rawName: "v-demo",
                        value: "guideTo",
                        expression: "'guideTo'",
                      },
                    ],
                    staticClass: "entry-oguide",
                  },
                  [
                    _c("icon-font", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { type: "gb-icon-helper-circle" },
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("layouts.operation.guide"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "a-dropdown",
                  { attrs: { trigger: ["click"] } },
                  [
                    _c(
                      "div",
                      { staticClass: "dropdown-content" },
                      [_c("a-icon", { attrs: { type: "down" } })],
                      1
                    ),
                    _c(
                      "a-menu",
                      {
                        attrs: { slot: "overlay" },
                        on: { click: _vm.closeMenuClick },
                        slot: "overlay",
                      },
                      [
                        _c("a-menu-item", { key: "ClosePane" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.current"))),
                        ]),
                        _c("a-menu-item", { key: "CloseRightPanes" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.right"))),
                        ]),
                        _c("a-menu-item", { key: "CloseLeftPanes" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.left"))),
                        ]),
                        _c("a-menu-item", { key: "CloseAllPane" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.all"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }